/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import { Container, Row, Column } from '../../../../styles/Grid';
import { COMPONENT_NAMES } from '../../../../utils/constants';
import * as dicts from '../../../../utils/dictionarykeys';
import getComponent from '../../../../utils/getComponent';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles.js';

const getStartOverURLFromContext = sitecoreContext => {
  const solutionBuilderNav = getComponent(
    sitecoreContext,
    COMPONENT_NAMES.solutionBuilderNav,
  );

  return get(solutionBuilderNav, 'fields.StartOverURL.value', '');
};

class StartOver extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { t, sitecoreContext } = props;
    const startOverURL = getStartOverURLFromContext(sitecoreContext);

    if (!startOverURL) {
      return null;
    }

    return (
      <section css={styles.startOver}>
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 12, xl: 12 }}>
              <a css={styles.startOverCta} href={startOverURL}>
                <i css={styles.startOverCtaIcon} className="icon-refresh" />
                <span css={styles.startOverCtaCopy}>
                  {t(dicts.SOLUTION_BUILDER.START_OVER_CTA)}
                </span>
              </a>
            </Column>
          </Row>
        </Container>
      </section>
    );
  }
}

StartOver.displayName = 'StartOver';

StartOver.defaultProps = {
  t: key => key,
};

StartOver.propTypes = {
  t: PropTypes.func,
};

export default compose(withNamespaces(), withSitecoreContext())(StartOver);
